import { render, staticRenderFns } from "./FormProductDinein.vue?vue&type=template&id=ee4ba61c&scoped=true"
import script from "./FormProductDinein.vue?vue&type=script&lang=js"
export * from "./FormProductDinein.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4ba61c",
  null
  
)

export default component.exports